import {Injectable} from "@angular/core";
import {LovListModel} from "../../api/model/lovList.model";
import {LovListConverter} from "../../api/model/converter/lovList.converter";
import {LovListService} from "./ngrx/lovList.service";
import {LovListDataService} from "./ngrx/lovListData.service";
import {EntityCollectionFindOneByAttributeService} from "../../../../../core/service/entityCollectionFindOneByAttributeService";


@Injectable()
export class LovListFindByNameService extends EntityCollectionFindOneByAttributeService<LovListModel, LovListConverter> {

    constructor(public service: LovListService,
                public dataService: LovListDataService) {
        super('LovListFindByNameService', service, dataService, new LovListConverter());
    }

    protected getAttributeName(): string {
        return "name";
    }
}